export default {
  labels: {
    sold_out: 'Sold out!',
    most_popular: '#{{rank}} Most Liked',
    bogo: 'Buy One, Get One Free',
  },
};
